

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class AnalyticAccount_ManagedObject

class AnalyticAccount_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: comments
    set comments(value:string) {
        this.setValueForKey(value, 'comments');
    }
    get comments():string {
        return this.valueForKey('comments');
    }
    set commentsPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'comments');
    }
    get commentsPrimitiveValue():string {
        return this.primitiveValueForKey('comments');
    }

    // Property: concept
    set concept(value:string) {
        this.setValueForKey(value, 'concept');
    }
    get concept():string {
        return this.valueForKey('concept');
    }
    set conceptPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'concept');
    }
    get conceptPrimitiveValue():string {
        return this.primitiveValueForKey('concept');
    }

    // Property: indexPath
    set indexPath(value:string) {
        this.setValueForKey(value, 'indexPath');
    }
    get indexPath():string {
        return this.valueForKey('indexPath');
    }
    set indexPathPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'indexPath');
    }
    get indexPathPrimitiveValue():string {
        return this.primitiveValueForKey('indexPath');
    }

    // Property: requiredLink
    set requiredLink(value:boolean) {
        this.setValueForKey(value, 'requiredLink');
    }
    get requiredLink():boolean {
        return this.valueForKey('requiredLink');
    }
    set requiredLinkPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'requiredLink');
    }
    get requiredLinkPrimitiveValue():boolean {
        return this.primitiveValueForKey('requiredLink');
    }

    // Property: title
    set title(value:string) {
        this.setValueForKey(value, 'title');
    }
    get title():string {
        return this.valueForKey('title');
    }
    set titlePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'title');
    }
    get titlePrimitiveValue():string {
        return this.primitiveValueForKey('title');
    }

    // Property: type
    set type(value:number) {
        this.setValueForKey(value, 'type');
    }
    get type():number {
        return this.valueForKey('type');
    }
    set typePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'type');
    }
    get typePrimitiveValue():number {
        return this.primitiveValueForKey('type');
    }

    // Relationship: children
    protected _children:MIOManagedObjectSet = null;
    get children():MIOManagedObjectSet {
        return this.valueForKey('children');
    }
    addChildrenObject(value:AnalyticAccount) {
        this._addObjectForKey(value, 'children');
    }
    removeChildrenObject(value:AnalyticAccount) {
        this._removeObjectForKey(value, 'children');
    }
    // Relationship: ledgerAccount
    set ledgerAccount(value:LedgerAccount) {
        this.setValueForKey(value, 'ledgerAccount');
    }
    get ledgerAccount():LedgerAccount {
        return this.valueForKey('ledgerAccount') as LedgerAccount;
    }
    // Relationship: parent
    set parent(value:AnalyticAccount) {
        this.setValueForKey(value, 'parent');
    }
    get parent():AnalyticAccount {
        return this.valueForKey('parent') as AnalyticAccount;
    }
}
